import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedCurrency } from '../../../components/formatted-currency';
import { LabeledRow } from '../../../fulfillment-planner/labeled-row';

import { messages } from '../../../fulfillment-planner/labeled-row/messages';
import { CurrencyPropType } from '../../../prop-types/currency';

import style from './style.module.css';

export const DriverTip = ({ driverTip }) => (
  <LabeledRow className={style.row} label={<FormattedMessage {...messages.driverTip} />} labelClassName={style.label}>
    {!driverTip ? (
      <span className={style.mdash}>&mdash;</span>
    ) : (
      <span className={style.info}>
        <FormattedCurrency currencyCode={driverTip.code} value={driverTip.value} />
      </span>
    )}
  </LabeledRow>
);

DriverTip.propTypes = {
  driverTip: CurrencyPropType,
};
